export default "__VITE_ASSET__DsGNdWL5__"